import React, { useEffect } from "react";
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";
import Layout from "./components/Layout";
import PageNotFound from "./pages/PageNotFound";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import AllJobs from "./pages/AllJobs";
import UserManagement from "./pages/UserManagement";
import JobDetails from "./pages/JobDetails";
import AdditionalRevenue from "./pages/AdditionalRevenue";
import UserProfile from "./pages/UserProfile";
import Otp from "./pages/Otp";
import CreatePassword from "./pages/CreatePassword";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import PrivateRoute from "./pages/PrivateRoute";
import JobConfiguration from "./pages/JobConfiguration";
import Company from "./pages/SuperDashboard";
import CreateJob from "./pages/CreateJob";
import VideoList from "./pages/VideoList";
import JobList from "./pages/JobList";
import Products from "./pages/Products";
import UploadExcel from "./pages/UploadExcel";
import { SearchItemsPage } from "./pages/SearchItemsPage";
import { AddedCartList } from "./pages/AddedCartList";
import CompanyManager from "./pages/CompanyManager";
import { currentUser, isAuthenticated } from "./helpers";
import MultistepperForm from "./pages/MultistepperForm";
import Adduser from "./pages/Adduser";
import Customization from "./pages/Customization";
import { GetMultiStepper } from "./service/authApi";
import TermsCondition from "./pages/TermsCondition";

const IndexPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (isAuthenticated()) navigate("/Dashboard");
  });
  return null;
};

const SignupFlow = () => {
  const navigate = useNavigate();
  const userInfo = currentUser();
  const checkStep = async () => {
    if (userInfo?.userRole && userInfo?.userRole === "CompanyAdmin") {
      try {
        const response = await GetMultiStepper(userInfo?.userId);
        if (response.data.multiStepper === false) {
          navigate("/signup-flow/create-job");
        } else if (response.data.addUser === false) {
          navigate("/signup-flow/add-user");
        } else navigate("/dashboard");
      } catch (error) {
        console.error("Error fetching multi-stepper data:", error);
      }
    } else {
      navigate("/login");
    }
  };
  useEffect(() => {
    checkStep();
  }, []);
  return <Outlet />;
};

const userInfo = JSON.parse(localStorage.getItem("AUTH_USER"));
const userRole = userInfo?.userRole;
// const userRole = "CompanyAdmin";

export default function Router() {
  const RoleBasedRoute = ({ element, allowedRoles }) => {
    return allowedRoles.includes(userRole) ? (
      element
    ) : (
      <Navigate to="/Dashboard" />
    );
  };

  return (
    <BrowserRouter>
      <Routes>
        {/* TODO: add proper route path for multi-stepper form */}
        <Route path="/Signup" element={<Signup />} />
        <Route path="/signup-flow" element={<SignupFlow />}>
          <Route path="/signup-flow/add-user" element={<Adduser />} />
          <Route
            path="/signup-flow/create-job"
            element={<MultistepperForm />}
          />
        </Route>
        <Route path="/Otp" element={<Otp />} />
        <Route path="/CreatePassword" element={<CreatePassword />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
        <Route path="/ResetPassword" element={<ResetPassword />} />
        <Route path="/login" element={<Login />} />
        <Route path="/TermsConditions" element={<TermsCondition />} />

        <Route path="/" element={<Layout />}>
          <Route index element={<IndexPage />} />
          {/* <Route path="" element={<PrivateRoute />}> */}
          <Route
            path="/Dashboard"
            element={
              <RoleBasedRoute
                element={<Dashboard />}
                allowedRoles={[
                  "SuperAdmin",
                  "CompanyAdmin",
                  "CompanyUser",
                  "CompanyManager",
                ]}
              />
            }
          />

          <Route
            path="/AllJobs"
            element={
              <RoleBasedRoute
                element={<AllJobs />}
                allowedRoles={[
                  "SuperAdmin",
                  "CompanyAdmin",
                  "CompanyUser",
                  "CompanyManager",
                ]}
              />
            }
          />
          <Route
            path="/AllJobs/:id"
            element={
              <RoleBasedRoute
                element={<AllJobs />}
                allowedRoles={[
                  "SuperAdmin",
                  "CompanyAdmin",
                  "CompanyUser",
                  "CompanyManager",
                ]}
              />
            }
          />
          <Route
            path="/JobList"
            element={
              <RoleBasedRoute
                element={<JobList />}
                allowedRoles={["CompanyAdmin", "CompanyUser", "CompanyManager"]}
              />
            }
          />
          <Route
            path="/JobDetails"
            element={
              <RoleBasedRoute
                element={<JobDetails />}
                allowedRoles={[
                  "SuperAdmin",
                  "CompanyAdmin",
                  "CompanyUser",
                  "CompanyManager",
                ]}
              />
            }
          />
          <Route
            path="/JobDetails/:id"
            element={
              <RoleBasedRoute
                element={<JobDetails />}
                allowedRoles={[
                  "SuperAdmin",
                  "CompanyAdmin",
                  "CompanyUser",
                  "CompanyManager",
                ]}
              />
            }
          />

          <Route
            path="/UserManagement"
            element={
              <RoleBasedRoute
                element={<UserManagement />}
                allowedRoles={["SuperAdmin", "CompanyAdmin", "CompanyManager"]}
              />
            }
          />
          <Route
            path="/Products"
            element={
              <RoleBasedRoute
                element={<Products />}
                allowedRoles={[
                  "SuperAdmin",
                  "CompanyAdmin",
                  "CompanyManager",
                  "CompanyUser",
                ]}
              />
            }
          />
          <Route
            path="/UploadExcel"
            element={
              <RoleBasedRoute
                element={<UploadExcel />}
                allowedRoles={["SuperAdmin", "CompanyAdmin"]}
              />
            }
          />
          <Route
            path="/AdditionalRevenue"
            element={
              <RoleBasedRoute
                element={<AdditionalRevenue />}
                allowedRoles={["CompanyAdmin", "CompanyUser", "CompanyManager"]}
              />
            }
          />
          <Route
            path="/VideoList"
            element={
              <RoleBasedRoute
                element={<VideoList />}
                allowedRoles={[
                  "SuperAdmin",
                  "CompanyAdmin",
                  "CompanyUser",
                  "CompanyManager",
                ]}
              />
            }
          />
          <Route
            path="/CreateJob"
            element={
              <RoleBasedRoute
                element={<CreateJob />}
                allowedRoles={[
                  "SuperAdmin",
                  "CompanyAdmin",
                  "CompanyUser",
                  "CompanyManager",
                ]}
              />
            }
          />

          <Route
            path="/EditJob/:id"
            element={
              <RoleBasedRoute
                element={<CreateJob />}
                allowedRoles={[
                  "SuperAdmin",
                  "CompanyAdmin",
                  "CompanyUser",
                  "CompanyManager",
                ]}
              />
            }
          />

          <Route
            path="/JobConfiguration"
            element={
              <RoleBasedRoute
                element={<JobConfiguration />}
                allowedRoles={["SuperAdmin", "CompanyAdmin", "CompanyManager"]}
              />
            }
          />
          <Route
            path="/JobConfiguration/:id"
            element={
              <RoleBasedRoute
                element={<JobConfiguration />}
                allowedRoles={["SuperAdmin", "CompanyAdmin", "CompanyManager"]}
              />
            }
          />
          <Route
            path="/content-management"
            element={
              <RoleBasedRoute
                element={<Customization />}
                allowedRoles={["SuperAdmin"]}
              />
            }
          />
          <Route
            path="/UserProfile"
            element={
              <RoleBasedRoute
                element={<UserProfile />}
                allowedRoles={[
                  "SuperAdmin",
                  "CompanyAdmin",
                  "CompanyUser",
                  "CompanyManager",
                ]}
              />
            }
          />
          <Route
            path="/CompanyManager"
            element={
              <RoleBasedRoute
                element={<CompanyManager />}
                allowedRoles={["CompanyAdmin"]}
              />
            }
          />
          <Route
            path="/SuperDashboard"
            element={
              <RoleBasedRoute
                element={<Company />}
                allowedRoles={["SuperAdmin"]}
              />
            }
          />
          <Route path="/search" element={<SearchItemsPage />} />
          <Route path="/cartListData" element={<AddedCartList />} />
          {/* </Route> */}
        </Route>
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
// const RoleBasedRoute = async ({ allowedRoles }) => {

//   const navigate = useNavigate();
//   if (allowedRoles.includes(userRole)) {
//     if (userRole === "CompanyAdmin") {
//       try {
//         const response = await GetMultiStepper(userInfo?.userId);
//         if (response.data.multiStepper === false) {
//           navigate("/create-job");
//         } else if (response.data.addUser === false) {
//           navigate("/add-user");
//         }
//       } catch (error) {
//         console.error("Error fetching multi-stepper data:", error);
//       }
//     }
//   } else {
//     navigate("/Dashboard"); // Redirect if the user does not have the required role
//   }
// };
